export default {
  verboseName: "Compagnia di trasporto",
  verboseNamePlural: "Compagnie di trasporto",
  modelName: "TransportCompany",
  modelNamePlural: "TransportCompanies",
  appName: "people",
  propName: "transportCompany",
  propNamePlural: "transportCompanies",
}
